import React, {useState, useEffect} from 'react';
import { LoadingContext, UserContext, ContextProcessor } from './components/partials/Context';
import {BrowserRouter as Router} from 'react-router';
import Routing from './Routing';


function App() {
  const [loading, setLoading] = useState(false); 
  const [user, setUser] = useState({});
  const [context_processor, setContextProcessor] = useState({});

  useEffect(()=> {
        let token = null
        if (window.location.pathname.startsWith('/oplac/')) {
            token = window.location.pathname.split('/')[2]
        }
        let headers = {};
        if (token) {
            headers['Authorization'] = `Token ${token}`
          }
        fetch("/api/users/current/", {headers: headers}).then(res =>
          res.json().then(data => {
          setUser(data)
        }))

        fetch("/api/context/").then(res =>
          res.json().then(data => {
          setContextProcessor(data)
        }))
  },[])
  
    return (
      <LoadingContext.Provider value={{loading, setLoading}}>
        <ContextProcessor.Provider value={context_processor}>
          <UserContext.Provider value={user}>
          <Router>
              <Routing user={user}/>
          </Router>
          </UserContext.Provider>
        </ContextProcessor.Provider>
      </LoadingContext.Provider>
    );
    
}

export default App;

